module.exports = __webpack_public_path__ + "static/media/ico-see-off.62e5b5fd.svg";